/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationErrorStatusKind =
  (typeof GroupByConversationErrorStatusKind)[keyof typeof GroupByConversationErrorStatusKind];

export const GroupByConversationErrorStatusKind = {
  conversation_error_status: 'conversation_error_status',
} as const;
